const isEmptyString = (value: unknown): value is string => typeof value === 'string' && value.trim() === '';

export function removeEmptyStrings<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map(removeEmptyStrings).filter((item) => item !== undefined) as T;
  }

  if (value && typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>).reduce<Record<string, unknown>>(
      (acc, [key, nestedValue]) => {
        const cleaned = removeEmptyStrings(nestedValue);

        if (cleaned === '' || cleaned === undefined || isEmptyString(cleaned)) {
          return acc;
        }

        acc[key] = cleaned;
        return acc;
      },
      {},
    ) as T;
  }

  return value;
}
